<template>
  <div class="conf-wrp">
    <div class="content-wrp">
      <div class="content">
        <el-form class="form" :model="value" :rules="rules" ref="form" label-width="20%">
          <section>
            <div class="title">
              <span>基础设置</span>
            </div>
            <div class="conf">
              <el-form-item label="最小起订量默认设置:">
                <el-switch v-model="value.beginAmountSwitch"></el-switch>
              </el-form-item>
              <el-form-item v-if="value.beginAmountSwitch">
                <div>
                  <span class="prev">最小起订量&nbsp;&nbsp;</span>
                  <el-input-number v-model="value.extendId1" controls-position="right" :min="0"></el-input-number>
                  <span class="text-tips" v-if="value.extendId1 == 1"
                    >&nbsp;设置起批量为1，满足条件时系统会默认支持7天无理由
                    <a href="https://show.1688.com/item/common/redirect.html?name=returnAddressNorm" target="_blank">点此了解规则</a></span
                  >
                </div>
              </el-form-item>
              <el-form-item label="发货地址:" prop="shipSet" label-width="120px">
                <div class="ship-wrp" style="display:inline-block;" v-if="shopList.length && Object.keys(shipsValue).length">
                  <div class="item" v-for="(item, idx) in shopList" :key="idx">
                    <div class="shopname">
                      <img :src="item.icon" class="shop-img" />
                      <el-tooltip v-if="item.channelIcon" :content="item.channelName" style="margin: 0px -6px 0px 6px">
                        <el-image :src="item.channelIcon" style="width: 18px; height: 18px; overflow: unset; top: 4px"></el-image>
                      </el-tooltip>
                      <span>{{ item.shortTitle || item.title }}</span>
                    </div>
                    <template>
                      <el-select
                        :loading="selectLoading"
                        v-model="addressValue[item.id].addressId"
                        placeholder="请选择发货地址"
                        clearable
                        filterable
                        @change="handleAddressChange(item.id, $event)" 
                        @visible-change="visible => visibleChangeAddress(visible, item.id, item.userId)"
                        width="500px"
                      >
                        <el-option
                          v-for="ship in addressTemplate[item.id]"
                          :key="ship.addressId"
                          :label="ship.addressName"
                          :value="ship.addressId"
                          style="width: 500px"
                        >
                        </el-option>
                      </el-select>
                    </template>
                  </div>
                </div>
                <span v-else class="no-shops">暂无平台店铺</span>
              </el-form-item>
            </div>
          </section>
          <section>
            <div class="title">
              <span>运费模板设置</span>
            </div>
            <div class="conf">
              <el-form-item label="运费设置:" prop="shipSet" label-width="120px">
                <div class="ship-wrp" v-if="shopList.length && Object.keys(shipsValue).length">
                  <div class="item" v-for="(item, idx) in shopList" :key="idx">
                    <div class="shopname">
                      <img :src="item.icon" class="shop-img" />
                      <el-tooltip v-if="item.channelIcon" :content="item.channelName" style="margin: 0px -6px 0px 6px">
                        <el-image :src="item.channelIcon" style="width: 18px; height: 18px; overflow: unset; top: 4px"></el-image>
                      </el-tooltip>
                      <span>{{ item.shortTitle || item.title }}</span>
                    </div>
                    <el-select
                      v-model="shipsValue[item.id].extendId1"
                      placeholder="请选择"
                      width="150px"
                      @change="tempTypeChange(item.id, item.userId)"
                    >
                      <el-option label="使用运费模版" value="T"> </el-option>
                      <el-option label="使用运费说明" value="C"> </el-option>
                      <el-option label="卖家承担运费" value="F"> </el-option>
                    </el-select>
                    <template v-if="['T'].includes(shipsValue[item.id].extendId1)">
                      <el-select
                        :loading="selectLoading"
                        v-model="shipsValue[item.id].templateId"
                        placeholder="请选择运费模板"
                        clearable
                        filterable
                        @visible-change="visible => visibleChange(visible, item.id, item.userId)"
                        width="150px"
                      >
                        <el-option
                          v-for="ship in shipsTemplate[item.id]"
                          :key="ship.templateId"
                          :label="ship.templateName"
                          :value="ship.templateId"
                          style="width: 150px"
                        >
                        </el-option>
                      </el-select>
                      <div><el-link class="no-border" @click="refreshTemplate(item.id, item.userId)">刷新模板</el-link></div>
                    </template>
                  </div>
                </div>
                <span v-else class="no-shops">暂无平台店铺</span>
              </el-form-item>
            </div>
          </section>
          <PriceConf ref="PriceConfRef" platform="1688" :priceList="value.price" :shopPriceConf="value.shopPriceConf"></PriceConf>
          <div class="btns">
            <el-button type="primary" @click="save">保存模板</el-button>
            <el-button @click="back">返回</el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import '@/assets/css/prod.scss';
import { getDistributionConfig, updateDistributionConfig } from '@servers/prod/conf/index.js';
import PriceConf from './components/PriceConf.vue';
import { getFreightTemplateList,batchAlibabaShippingAddress } from '@/servers/prod/center/alibaba';

// import PriceConf from './components/PriceConf.vue';

const PLATFORMID = '1688';

export default {
  props: {
    back: Function,
  },
  components: {
      PriceConf
  },
  data() {
    return {
      activeName: 'propTemplate',
      shopList: [],
      value: {
        beginAmountSwitch: false, // 最小起订量默认设置
        extendId1: 1, // 最小起订量
      },
      selectLoading: false,
      rules: {
        // extendId1: [{ required: true, message: '' }],
      },
      shipsValue: {
        // 运费模板
      },
      shipsTemplate: {
        // 运费模板列表
      },
      addressValue:{}, //运费模版值
      addressTemplate: {}, //发货地址模版立碑
      shipsTemplateCaches: {},
      addressTemplateCaches: {}, // 发货地址模版缓存  
    };
  },
  mounted() {
    this.getConf();
  },
  methods: {
    async getConf() {
      const res = await getDistributionConfig({ shopType: PLATFORMID });
      const shopList = this.$store.getters.get_AllShops_BySource('1688');
      this.shopList = shopList;
      if (res) {
        this.value.beginAmountSwitch = res.beginAmountSwitch;
        this.value.extendId1= res.extendId1;
        this.value.price= res.price ? JSON.parse(res.price) : [];
        this.value.shopPriceConf= res.shopPriceConf ? JSON.parse(res.shopPriceConf) : [];
        // this.value = {
        //   ...this.value,
        //   beginAmountSwitch: res.beginAmountSwitch,
        //   extendId1: res.extendId1,
        //   price: res.price ? JSON.parse(res.price) : [],
        //   shopPriceConf: res.shopPriceConf ? JSON.parse(res.shopPriceConf) : [],
        // };
      }
      this.intiTemplate(res?.templateList || []);
      // 发货地址设置
      this.initShipAddressTemplate(res?.sendAddressTemplateList || [])
    },
    intiTemplate(templateList) {
      const shopList = this.shopList;
      const ships = {};
      const shipsTemp = {};
      shopList.forEach(shop => {
        const { id, channel } = shop;
        const findTemp = templateList.find(temp => temp.shopId == id);
        ships[id] = {
          shopId: id,
          templateId: '',
          templateName: '',
          channel,
          extendId1: '',
          valuation: null,
          ...findTemp,
        };
        if (findTemp) {
          shipsTemp[id] = [{ templateName: findTemp.templateName, templateId: findTemp.templateId }];
        }
      });
      this.shipsTemplate = shipsTemp;
      this.shipsValue = ships;
    },
    // 根据接口返回的发货地址数据进行初始化
    initShipAddressTemplate(addressTemplateList) {
      const shopList = this.shopList;
      
      // 初始化每个店铺的地址值
      shopList.forEach(shop => {
        const { id } = shop;
        if (!this.addressValue[id]) {
          this.$set(this.addressValue, id, {
            shopId: id,
            addressId: '',
            addressName: ''
          });
        }
        if (!this.addressTemplate[id]) {
          this.$set(this.addressTemplate, id, []);
        }
      });

      // 如果有初始数据，更新对应的值
      if (addressTemplateList?.length) {
        addressTemplateList.forEach(temp => {
          if (temp.shopId) {
            this.$set(this.addressValue, temp.shopId, {
              shopId: temp.shopId,
              addressId: temp.addressId || '',
              addressName: temp.addressName || ''
            });
          }
           // 同时设置模板数据
          this.$set(this.addressTemplate, temp.shopId, [{
            addressId: temp.addressId,
            addressName: temp.addressName
          }]);
        });
      }
    },

    handleAddressChange(shopId, addressId) {
      // 找到对应的地址信息
      const selectedAddress = this.addressTemplate[shopId]?.find(item => item.addressId === addressId);
      if (selectedAddress) {
        // 更新 addressValue
        this.addressValue[shopId] = {
          ...this.addressValue[shopId],
          addressId: selectedAddress.addressId,
          addressName: selectedAddress.addressName
        };
      }
    },
    tempTypeChange(shopId, userId) {
      this.getTemplateList(shopId, userId);
    },

    async visibleChange(visible, shopId, userId) {
      if (!visible) return;
      const curShipsTemp = this.shipsTemplate[shopId];
      const curValue = this.shipsValue[shopId];
      //   if (!curShipsTemp?.length || (curShipsTemp?.length === 1 && curShipsTemp[0].id === curValue.templateId)) {
      await this.getTemplateList(shopId, userId);
      //   }
    },
    // 发货地址默认展示的列表内容
    async visibleChangeAddress(visible, shopId, userId) {
      if (!visible) return;
      await this.getShopAddressList({shopId, userId});
    },

    // 获取店铺列表的发货地址
    async getShopAddressList({shopId,userId,isRefresh}){
    const addressCacheType = 'addressCacheType';
    const cacheKey = `${shopId}_${addressCacheType}`;
    if (this.addressTemplateCaches[cacheKey] && !isRefresh) {
        this.addressTemplate[shopId] = this.addressTemplateCaches[cacheKey];
      } else {
            this.selectLoading = true;
            const res = await batchAlibabaShippingAddress({userId})
            if(res.result && res.result.length){
                const list = res.result.map(item => ({ addressId: item.id + '', addressName: item.fullAddress }));
                this.addressTemplate[shopId] = list;
                this.addressTemplateCaches[cacheKey] = list;
                this.selectLoading = false;
            } else {
              // 错误处理
              this.addressTemplate[shopId] = [];
                this.selectLoading = false;
            }
      }
    },

    async getTemplateList(shopId, userId, isRefresh) {
      const freightType = this.shipsValue[shopId].extendId1;
      if (!['T'].includes(freightType)) return;
      const cacheKey = `${shopId}_${freightType}`;
      if (this.shipsTemplateCaches[cacheKey] && !isRefresh) {
        this.shipsTemplate[shopId] = this.shipsTemplateCaches[cacheKey];
      } else {
        this.selectLoading = true;
        const res = await getFreightTemplateList({ userId, webSite: '1688', type: freightType });
        const list = res.map(item => ({ templateId: item.id + '', templateName: item.name }));
        const curValue = this.shipsValue[shopId];
        const findItem = (list || []).find(item => item.templateId === curValue.templateId);
        if (!findItem) {
          this.shipsValue[shopId].templateId = '';
          this.shipsValue[shopId].templateName = '';
        }

        this.shipsTemplate[shopId] = list;
        this.shipsTemplateCaches[cacheKey] = list;
        this.selectLoading = false;
      }
    },
    async refreshTemplate(shopId, userId) {
      await this.getTemplateList(shopId, userId, true);
      this.$message.success('刷新模板成功');
    },

    findTemplateName({ shopId, templateId }) {
      if (!templateId || !this.shipsTemplate[shopId]?.length) return '';
      return this.shipsTemplate[shopId].find(temp => temp.templateId === templateId)?.templateName || '';
    },
    save() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          const { extendId1, beginAmountSwitch } = this.value;
          const templateList = [];
          const sendAddressTemplateList = []; // 添加发货地址列表
          this.shopList.forEach(shop => {
            const curValue = this.shipsValue[shop.id];
            if (curValue.extendId1) {
              const item = {
                ...curValue,
              };
              if (!['T'].includes(curValue.extendId1)) {
                item.templateId = '';
                item.templateName = '';
              } else {
                const templateName = this.findTemplateName(curValue);
                item.templateName = templateName;
              }
              templateList.push(item);
            }
            // 处理发货地址数据
            const addressValue = this.addressValue[shop.id];
            if (addressValue?.addressId) {
              const item = {
                ...addressValue,
              };
              sendAddressTemplateList.push({
                shopId: shop.id,
                addressId: addressValue.addressId,
                addressName: addressValue.addressName,
                ...item,
              });
            }

          });
           let [commConf,shopConf] = this.$refs.PriceConfRef.getData();
          const res = await updateDistributionConfig({
            shopType: PLATFORMID,
            extendId1,
            beginAmountSwitch,
            templateList: templateList,
            price: JSON.stringify(commConf),
            shopPriceConf:JSON.stringify(shopConf),
            sendAddressTemplateList, // 添加到请求参数
          });
          if (res) {
            this.$message.success('保存成功');
          }
        }
      });
    },
  },
};
</script>

<style lang="scss">
</style>